module.exports = __webpack_public_path__ + "img/w_other.0ce77497.svg";